import { authService } from '../service/domain/_service.config'
import { logError } from './errorLogger'

/**
 * Restores Supabase session from URL hash when user navigates from native app
 * to web for payment. Only acts if #session= is present in the URL hash;
 * no-op on all other page loads. Called from index.tsx before app renders.
 */
export async function restoreSessionFromHash(): Promise<void> {
  if (typeof window === 'undefined') return

  const hash = window.location.hash
  if (!hash) return

  const sessionMatch = hash.match(/#session=(.+)/)
  if (!sessionMatch) return

  try {
    const sessionJson = decodeURIComponent(sessionMatch[1])
    const sessionData = JSON.parse(sessionJson) as {
      access_token: string
      refresh_token: string
      expires_at?: number
    }

    if (sessionData.access_token && sessionData.refresh_token) {
      await authService.setSession({
        access_token: sessionData.access_token,
        refresh_token: sessionData.refresh_token,
        expires_at: sessionData.expires_at,
      })

      window.history.replaceState(null, '', window.location.pathname + window.location.search)
    }
  } catch (error) {
    void logError(error, { source: 'sessionRestorer' })
    window.history.replaceState(null, '', window.location.pathname + window.location.search)
  }
}
